// Mui Components
import { CardActionArea, Typography, Box } from "@mui/material";

// Components
import ContentCard from "../../@core/content-card";

// Icons
import LanistarIcon from "../../../assets/images/img@lanistar.svg";
import HUHIcon from "../../../assets/images/img@huh.png";

// Styles
import { styles } from "./styles";

const values = [
  {
    icon: LanistarIcon,
    name: "Lanistar Ltd Contract",
    label: "Online Challenger Bank",
  },
  {
    icon: HUHIcon,
    name: "HUH Token Contract",
    label: "Crypto Currency Token",
  },
];

const Stats = props => {
  const { projects } = props
  return (
    <ContentCard label="Available Projects" transparent>
      <Box sx={styles.items}>
        {projects.map((item, idx) => {
          return (
            <CardActionArea sx={styles.item} key={idx}>
              <Box sx={styles.icon}>
                <img src={item.logoUrl} alt={item.name} />
              </Box>
              <Box sx={styles.text}>
                <Typography sx={styles.name}>{item.name}</Typography>
                <Typography sx={styles.label}>{item.title}</Typography>
              </Box>
            </CardActionArea>
          );
        })}
      </Box>
    </ContentCard>
  );
};

export default Stats;
